import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import useTablePaginationConfig from '../../hooks/useTablePaginationConfig'
import { DEFAULT_PAGE_SAZE } from '../../common/PrimeTable/CustomPrimeTable'
import { getContactsByPhoneNumber } from './services/incominCallServices'
import Loader from '../Loader/BasicLoader'
import CustomPrimeTable from '../../common/PrimeTable/CustomPrimeTable'
import { Button, Col, Row } from 'reactstrap'
import { setModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { INCOMING_CALL } from '../../constants/activityTypes'
import CustomModal, { useModal } from '../../common/CustomModal/CustomModal'
import AddNewContact from '../Contacts/TableOfContacts/AddNewContact'

const DEFAULT_SORT_META = [{ field: 'name', order: -1 }]

const ContactsByPhoneNumber = ({ phoneNumber, callId, customOnSaveActivity }) => {
  const { isModalOpen, toggleModal } = useModal()

  const dispatch = useDispatch()
  const { userData } = useSelector((state) => ({
    userData: state.auth.user,
  }))
  const [contactData, setContactData] = useState({
    data: [],
    query: {
      limit: DEFAULT_PAGE_SAZE,
      first: 0,
      totalRecords: 0,
    },
  })
  const [isLoading, setIsLoading] = useState(false)

  const { options, onFilterChange, onPageChange, onSortChange } = useTablePaginationConfig({
    name: -1,
  })

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true)
      const response = await getContactsByPhoneNumber(options, phoneNumber)
      if (response && response.data) {
        setContactData(response.data)
      }
      setIsLoading(false)
    }

    loadData()
  }, [options])

  const fetchContacts = async () => {
    setIsLoading(true)
    const response = await getContactsByPhoneNumber(options, phoneNumber)
    if (response && response.data) {
      setContactData(response.data)
    }
    setIsLoading(false)
  }

  const signInToContact = (query) => {
    window.open(
      `${window.location.origin}/sign-in-as?user=${userData.userId}&signas=${userData.userId}&query=${query}`,
      '_blank'
    )
  }

  const sortMeta = () => {
    if (options?.sort) {
      const field = Object.keys(options?.sort)[0]
      const order = options?.sort[field]

      return [
        {
          field,
          order,
        },
      ]
    } else {
      return DEFAULT_SORT_META
    }
  }

  const nameBody = (rowData) => {
    return (
      <span onClick={() => signInToContact(`/contacts/${rowData.id}`)} className='incoming-call-card__link'>
        {rowData.name}
      </span>
    )
  }

  const statusBody = (rowData) => {
    return <span>{rowData.statusData.name}</span>
  }

  const stateBody = (rowData) => {
    return <span>{rowData.stateData.name}</span>
  }

  const organizationTypeBody = (rowData) => {
    return <span>{rowData.organizationTypeData.name}</span>
  }

  const assignedBody = (rowData) => {
    return <span>{rowData.assignedData.name}</span>
  }

  const addActivity = (rowData) => {
    return (
      <Button
        className='btn btn-sm btn-warning p-1'
        onClick={() => {
          dispatch(
            setModal({
              id: 'clickToCall',
              name: 'Edit Activity',
              props: {
                defaultActivityType: INCOMING_CALL,
                activityTypeDisabled: true,
                contactIdProps: rowData.id,
                subjectTextProps: '',
                isActivityFromCall: true,
                callId,
                contactIdForCall: rowData.id,
                customOnSaveActivity: customOnSaveActivity,
              },
            })
          )
        }}
      >
        Add Activity
      </Button>
    )
  }

  const columns = [
    { field: `name`, header: 'Name', body: nameBody },
    { field: 's.name', header: 'Status', body: statusBody },
    { field: `ownerName`, header: 'Company Owner' },
    { field: `st.name`, header: 'State', body: stateBody },
    { field: `dateEstablished`, header: 'Date Established', format: 'MM-DD-YYYY' },
    { field: 'st1.name', header: 'Organization Type', body: organizationTypeBody },
    { field: `mcNumber`, header: 'MC Number' },
    { field: 'dotNumber', header: 'DOT Number' },
    { field: 'u.id', header: 'Assigned', body: assignedBody },
    { field: 'add', header: 'Add Activity', body: addActivity, sortable: false },
  ]

  return (
    <div>
      {isLoading && <Loader />}
      <Row className={'incoming-call-contacts__header'}>
        <Col className={'d-flex justify-content-end'}>
          <CustomModal isOpen={isModalOpen} toggle={() => toggleModal('isAddContactModal')} headerText={'Add Contact'}>
            <AddNewContact
              phoneNumber={phoneNumber}
              isIncomingCallNewContact
              callback={fetchContacts}
              toggleModal={() => toggleModal('isAddContactModal')}
            />
          </CustomModal>
          <i
            className={'fas fa-plus-square incoming-call-contacts__new'}
            onClick={() => toggleModal('isAddContactModal')}
          />
        </Col>
      </Row>
      <CustomPrimeTable
        data={contactData.data}
        columns={columns}
        defaultSortMeta={sortMeta()}
        onPage={onPageChange}
        onSort={onSortChange}
        onFilter={onFilterChange}
        query={contactData.query}
        findHidden={true}
        addHidden
        showActions={false}
      />
    </div>
  )
}

export default ContactsByPhoneNumber
